import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, FeatureCard, CtaBand, Reveal } from "../components/ui.js";

/* LEVELUP ONE — บริษัท (Company) */
export default class Company extends Component {
  componentDidMount() { loading(false); window.scrollTo(0, 0); }
  render() {
    const info = [
      { icon: "🏢", title: "ชื่อบริษัท", desc: "บริษัท เลเวลอัพ วัน จำกัด" },
      { icon: "📍", title: "ที่ตั้ง", desc: "จังหวัดระยอง ประเทศไทย" },
      { icon: "🧾", title: "จดทะเบียน", desc: "จดทะเบียนพาณิชย์ (DBD) ถูกต้องตามกฎหมาย" },
      { icon: "💳", title: "ระบบชำระเงิน", desc: "รองรับช่องทางชำระเงินที่ปลอดภัยผ่านพาร์ตเนอร์" },
      { icon: "🌏", title: "ขอบเขตบริการ", desc: "ทำในไทย ส่งมอบให้ลูกค้าทั่วโลก" },
      { icon: "🤝", title: "พันธมิตร", desc: "AWS, OpenAI, LINE, Cloudflare และอื่น ๆ" },
    ];
    return (
      <div className="nx">
        <Navbar />
        <PageHero crumb="บริษัท" eyebrow="ข้อมูลบริษัท" title="รู้จัก LevelUp One ให้มากขึ้น"
          subtitle="ข้อมูลทางการของบริษัท ที่ตั้ง และมาตรฐานที่เรายึดถือ" />
        <section className="nx-section">
          <div className="container">
            <div className="row g-4">
              {info.map((c, i) => (
                <div className="col-12 col-sm-6 col-lg-4" key={c.title}>
                  <Reveal delay={i * 50}><FeatureCard {...c} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="nx-section--tight">
          <div className="container">
            <Reveal>
              <div className="nx-band">
                <div className="row g-4 text-center position-relative">
                  <div className="col-6 col-lg-3"><div className="nx-band__num">120<span>+</span></div><div className="nx-band__label">โปรเจกต์ส่งมอบ</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num">50<span>+</span></div><div className="nx-band__label">ลูกค้าองค์กร</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num">4</div><div className="nx-band__label">ภูมิภาคที่ให้บริการ</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num">12<span>+</span></div><div className="nx-band__label">เดือนใช้งานต่อเนื่อง</div></div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal><SectionHead center eyebrow="ติดต่อบริษัท" title="ช่องทางติดต่อ" subtitle="ทีมงานพร้อมตอบกลับภายใน 1 ชั่วโมงในเวลาทำการ" /></Reveal>
            <div className="row g-4 mt-2">
              <div className="col-12 col-md-4"><Reveal><FeatureCard icon="📞" title="โทรศัพท์" desc="+66 93 130 4223" /></Reveal></div>
              <div className="col-12 col-md-4"><Reveal delay={60}><FeatureCard icon="✉️" title="อีเมล" desc="info@levelupone.ai" /></Reveal></div>
              <div className="col-12 col-md-4"><Reveal delay={120}><FeatureCard icon="💬" title="LINE Official" desc="@levelupone.ai" /></Reveal></div>
            </div>
          </div>
        </section>
        <CtaBand />
        <Footer />
      </div>
    );
  }
}
